import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  CanhotoPrestacaoContasStatus,
  CustomInputTextArea,
  CustomModal,
  InputNumeroInteiro,
  InputText,
} from '../../../../../components'
import { hideLoadingBox, showMessageBox } from '../../../../../store/actions/system.actions'
import useModalValidacaoCanhoto, { LOAD_MESSAGE } from './ModalValidacaoCanhotoHook'

function ModalValidacaoCanhoto({ dispatch, onResponse, modal }) {
  const { state, localDispatch } = useModalValidacaoCanhoto()

  useEffect(() => {
    if (modal.show) localDispatch.onInit(modal.data)
  }, [modal.show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      isVisible={modal.show}
      header={'Validação de Canhoto - Dados do Canhoto'}
      width={800}
      onClose={() => onResponse('close', null)}
    >
      <div className="p-grid">
        <div className="p-col-5">
          <InputText
            label="Operador Logístico:"
            marginTop={10}
            value={state.canhoto.tp_name}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-5">
          <InputText
            label="Transportadora"
            value={state.canhoto.transportadora_name}
            marginTop={10}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-2">
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              fontSize: '0.8rem',
              color: 'rgb(20, 176, 191)',
              marginTop: '35px',
            }}
          >
            <span style={{ marginRight: '5px' }}>Status:</span>
            <CanhotoPrestacaoContasStatus status={state.canhoto.status} />
          </div>
        </div>
        <div className="p-col-5">
          <InputText
            label="Veiculo de Entrega:"
            marginTop={10}
            value={state.canhoto.vehicle_badge}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-5">
          <InputText
            label="Nome do Patrimonio"
            marginTop={10}
            value={state.canhoto.patrimonio_name}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-2">
          <InputNumeroInteiro
            label="Quantidade"
            marginTop={10}
            value={state.canhoto.qte}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Nota Fiscal do Canhoto:"
            marginTop={10}
            value={state.canhoto.num_nf_canhoto}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Data da Prestação de Contas:"
            marginTop={10}
            value={state.canhoto.prestacao_contas_data}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        {state.canhoto.observacao ? (
          <div className="p-col-12">
            <CustomInputTextArea
              label="Observação"
              value={state.canhoto.observacao}
              disabled={true}
              onChange={() => {}}
              rows={3}
            />
          </div>
        ) : null}
        {state.canhoto.client_name ? (
          <div className="p-col-12">
            <InputText
              label="Cliente:"
              marginTop={10}
              value={state.canhoto.client_name}
              disabled={true}
              onChange={() => {}}
            />
          </div>
        ) : null}
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalValidacaoCanhoto)
